import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';
import { SystemService } from '@shared/service/system/system.service';
import { LocalStorageKeys } from '../auth/model/enums/local-storage.keys';

@Injectable({ providedIn: 'root' })
export class OrganisationsViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);
  private systemService = inject(SystemService);

  canActivate(): Promise<boolean> {
    return this.routeGuardService.handleRoute(this.getView());
  }
  getView(): View {
    let selectedProjectId = this.systemService.selectedProject;

    // Fallback to localStorage if SystemService hasn't initialized yet
    if (!selectedProjectId) {
      selectedProjectId = localStorage.getItem(LocalStorageKeys.SELECTED_PROJECT_ID);
    }

    let companyId = selectedProjectId ? this.systemService.getCompanyIdFromProject(selectedProjectId) : null;

    // If getCompanyIdFromProject returns null (SystemService not initialized yet),
    // fall back to SELECTED_COMPANY_ID from localStorage
    if (!companyId) {
      const storedCompanyId = localStorage.getItem(LocalStorageKeys.SELECTED_COMPANY_ID);
      // Only use if it's not the default "All Organizations" value
      if (storedCompanyId && storedCompanyId !== 'All Organizations') {
        companyId = storedCompanyId;
      }
    }

    if (companyId) {
      return {
        route: `companies/${companyId}`,
        iframeUrl: `company/${companyId}`,
      };
    }

    // Fallback to generic companies route if no company found
    return {
      route: 'companies',
      iframeUrl: 'companies',
    };
  }
}
